export const PENDO_EVENT_ALBUMS_ADD_MEDIA_TO_ALBUM_FROM_ALBUM = 'add-media-to-album-from-album';
export const PENDO_EVENT_ALBUMS_ADD_MEDIA_TO_ALBUM_FROM_MEDIA_LIST =
    'add-media-to-album-from-media-list';
export const PENDO_EVENT_ALBUMS_ADD_MEDIA_TO_ALBUM_FROM_MEDIAVIEWER =
    'add-media-to-album-from-media-viewer';

export const PENDO_EVENT_ANALYTICS_DATEPICKER_PERIOD = 'user-changes-dates-datepicker';

export const PENDO_EVENT_POST_ADD_LABEL_FROM_MEDIA_LIST = 'add-label-to-media-from-media-list';
export const PENDO_EVENT_POST_ADD_LABEL_FROM_MEDIAVIEWER = 'add-label-to-media-from-media-viewer';

export const PENDO_EVENT_SCHEDULER_MEDIA_LIBRARY_DROP_CALENDAR =
    'scheduler-media-post-created-media-library-calendar';
export const PENDO_EVENT_SCHEDULER_MEDIA_LIBRARY_DROP_FEEDVIEW =
    'scheduler-media-post-created-media-library-feedview';

export const PENDO_EVENT_SIGNUP_FAQ_LINK = 'signup-add-social-profile-cantfind-contactus';
export const PENDO_EVENT_SIGNUP_POPIN_CONFIRM_EMAIL_SUCCESS_CLOSE = 'signup-popin-confirm-close';
export const PENDO_EVENT_SIGNUP_ADD_SP_FAIL = 'signup-add-social-profile-fail';

export const PENDO_EVENT_DASHBOARD_ADD_WIDGET_TITLE = 'dashboard-add-widget-title';
export const PENDO_EVENT_DASHBOARD_ADD_WIDGET_STICKY = 'dashboard-add-widget-sticky';
export const PENDO_EVENT_DASHBOARD_ADD_WIDGET_IMAGE = 'dashboard-add-widget-image';
export const PENDO_EVENT_DASHBOARD_WIDGET_UPLOAD_IMAGE = 'dashboard-widget-upload-image';
export const PENDO_EVENT_DASHBOARD_ADD_WIDGET_SECTION = 'dashboard-add-widget-section';
export const PENDO_EVENT_DASHBOARD_CUSTOM_ADD_IMAGE = 'dashboard-custom-add-image';

export const PENDO_CORE_ANALYTICS = 'core-analytics';
export const PENDO_CORE_COLLABORATION = 'core-collaboration';
export const PENDO_CORE_DASHBOARD = 'core-dashboard';
export const PENDO_CORE_LISTENING = 'core-listening';
export const PENDO_CORE_ALBUMS = 'core-albums';
export const PENDO_CORE_CONTENT = 'core-content';
